// src/pages/MasjidPublicLayout.jsx
import { useEffect, useMemo, useState } from "react";
import { Outlet, useParams, useNavigate, useLocation } from "react-router-dom";
import { collection, onSnapshot, query, where, limit } from "firebase/firestore";
import { dbAdmin } from "../firebaseConfig";
import NotFound from "./NotFound";
import { capitalizeWords } from "../utils/formatHelpers";
import { FiArrowLeft } from "react-icons/fi";

import "../styles/Body.css";
import "../styles/MasjidPublic.css";

export default function MasjidPublicLayout() {
    const { slug } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [loading, setLoading] = useState(true);
    const [masjid, setMasjid] = useState(null);




    // ============
    // Back button logic
    // ============
    const isInternalReferrer =
        document.referrer && document.referrer.includes(window.location.origin);

    const showBackButton = location.state?.from === "home" || isInternalReferrer;

    // ============
    // ✅ Load masjid ikut slug
    // - Kalau user masuk /l/:slug, params slug tetap betul sebab route /l/:slug pun ada
    // ============
    useEffect(() => {
        if (!slug) {
            setMasjid(null);
            setLoading(false);
            return;
        }
        const s = String(slug).trim().toLowerCase();
        setLoading(true);

        // ✅ Query by profail.slug
        const qRef = query(
            collection(dbAdmin, "masajid"),
            where("profail.slug", "==", s),
            limit(1)
        );

        const unsub = onSnapshot(
            qRef,
            (snap) => {
                if (snap.empty) {
                    setMasjid(null);
                    setLoading(false);
                    return;
                }
                const d = snap.docs[0];
                setMasjid({ id: d.id, ...(d.data() || {}) });
                setLoading(false);
            },
            (err) => {
                console.error("❌ MasjidPublic load error:", err);
                setMasjid(null);
                setLoading(false);
            }
        );

        return () => unsub();
    }, [slug]);

    const p = masjid?.profail || {};

    const masjidName = useMemo(
        () => capitalizeWords(p?.nama || masjid?.nama || "Masjid"),
        [p?.nama, masjid?.nama]
    );

    const masjidLogo = useMemo(
        () => p?.logo || p?.logoJa || p?.gambar || masjid?.logo || masjid?.gambar || "",
        [p?.logo, p?.logoJa, p?.gambar, masjid?.logo, masjid?.gambar]
    );

    const bannerImg = useMemo(
        () => p?.gambar || masjid?.gambar || masjidLogo || "",
        [p?.gambar, masjid?.gambar, masjidLogo]
    );

    const handleClose = () => {
        if (window.history.length > 1) navigate(-1);
        else navigate("/", { replace: true });
    };

    if (!loading && !masjid) return <NotFound />;

    return (
        <div className="masjid-public">
            {/* floating back (logo etikaf) */}
            <div
                className="floating-back-icon-only"
                onClick={() => navigate("/", { replace: true })}
                role="button"
                aria-label="Kembali"
            >
                <img src="/assets/etikaf-box.svg" alt="Kembali" />
            </div>

            {/* HERO + HEADER */}
            <div className="mp-container">
                <div className="card-image masjid-hero-image">
                    {bannerImg ? <img src={bannerImg} alt="Masjid" /> : <div className="card-image-fallback" />}

                    {showBackButton && (
                        <button className="hero-back-btn" onClick={handleClose} aria-label="Kembali">
                            <FiArrowLeft />
                        </button>
                    )}

                    <div className="masjid-hero-overlay" />
                </div>

                <div className="mosque-row">
                    {masjidLogo && (
                        <img
                            className="mosque-logo"
                            src={masjidLogo}
                            alt="Logo masjid"
                            onError={(e) => (e.currentTarget.style.display = "none")}
                        />
                    )}
                    <div>
                        <p className="mosque-name-body">{masjidName}</p>
                    </div>
                </div>
            </div>

            {/* ✅ Content ikut route */}
            <Outlet context={{ masjid, masjidName, masjidLogo, bannerImg, masjidId: masjid?.id }} />

            {/* Footer */}
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100px",
                    cursor: "pointer",
                    textAlign: "center",
                }}
                onClick={handleClose}
            >
                <span>etikaf.com</span>
                <span>/{p?.slug || slug}</span>
            </div>
        </div>
    );
}
